import { combineReducers, configureStore } from "@reduxjs/toolkit";
import counterReducer from "./features/auth/Auth";
import Auth from "./features/auth/Auth";
import cartReducer from './features/cart/cartSlice'
import productReducer from "./features/products/productSlice";
import { persistReducer, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};

const reducer = combineReducers({
  counter: counterReducer,
  auth: Auth,
  cartProduct: cartReducer,
  product: productReducer,
  
});
const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: { ignoreActions: [REGISTER] } }),
});
